export default __webpack_public_path__ + "static/media/commerce.e1abb233.svg";